import React, { useContext } from 'react';

import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { Typography, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title, Text } = Typography;

const COLUMNS = [
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.reviewLog.reviewedBy'
    ),
    dataIndex: 'reviewedBy',
    key: 'reviewedBy',
    width: '30%',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.reviewLog.role'
    ),
    dataIndex: 'role',
    key: 'role',
    width: '30%',
  },
  {
    title: getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.review.reviewLog.recommendation'
    ),
    dataIndex: 'recommendation',
    key: 'recommendation',
    width: '30%',
  },
  {
    key: 'actions',
    render() {
      return <Button type="link" icon={<EditOutlined />} disabled />;
    },
  },
];

const ReviewLog = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);

  const dataSource = application?.reviews?.map((review) => ({
    key: review?.id,
    reviewedBy: review?.reviewing_agent?.full_name,
    role: 'Reviewer',
    recommendation: review?.recommendation_verbiage,
    notes: review?.notes,
  }));

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.reviewLog'
        )}
      </Title>
      <Table
        dataSource={dataSource}
        columns={COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        expandedRowRender={(record) => <Text>{record.notes}</Text>}
        rowExpandable={(record) => record.notes}
      ></Table>
    </>
  );
};

export default ReviewLog;
